export const OrderSource = Object.freeze({
  TikTok: 0,
  Instagram: 1,
  Site: 2,
  SiteTarget: 3,
  Facebook: 4,
});

const orderSourceDefinitions = Object.freeze([
  { id: OrderSource.TikTok, key: "OrderPage.source.tiktok" },
  { id: OrderSource.Instagram, key: "OrderPage.source.instagram" },
  { id: OrderSource.Site, key: "OrderPage.source.site" },
  { id: OrderSource.SiteTarget, key: "OrderPage.source.siteTarget" },
  { id: OrderSource.Facebook, key: "OrderPage.source.facebook" },
]);

export function getOrderSourceOptions(localize, options = {}) {
  const { includeEmpty = false } = options;
  const result = orderSourceDefinitions.map((item) => ({
    id: item.id,
    name: localize(item.key),
  }));

  if (includeEmpty) {
    return [
      {
        id: null,
        name: localize("OrderPage.source.notSpecified"),
      },
      ...result,
    ];
  }

  return result;
}
